import { Injectable } from "@angular/core";
import { DbDaoBase } from "../../../gyzmo-commons/dao/db/base/db.dao.base";
import { isNullOrEmpty } from "../../../gyzmo-commons/helpers/null.helper";
import { AppSqlProvider } from "../../../gyzmo-commons/persistence/app.sql.provider";
import { LoggerService } from "../../../gyzmo-commons/services/logs/logger.service";
import { DriverInfo } from "../../models/driverInfo.model";

@Injectable({
    providedIn: "root",
})
export class DriverInfoDbDao extends DbDaoBase<DriverInfo> {
    constructor(logger: LoggerService,
                private sqlProvider: AppSqlProvider) {
        super(logger);
    }

    public async createIndexes(): Promise<void> {
    }

    public createTable(): Promise<void> {
        const query = `CREATE TABLE IF NOT EXISTS ${ DriverInfo.TABLENAME } (
            id TEXT PRIMARY KEY,
            birthDate DATE,
            driverLicenseNumber TEXT,
            driverLicenseIssuingDate DATE,
            driverLicenseIssuingPlace TEXT
        );`;
        return this.sqlProvider.query(query, [])
            .then(async () => {
                await this.createIndexes();
            })
            .catch(reason => {
                this.logSqlError(reason);
                return null;
            });
    }

    public delete(id: string): Promise<any> {
        const query = `DELETE FROM ${ DriverInfo.TABLENAME } WHERE id = ?;`;
        return this.sqlProvider.query(query, [id]);
    }

    deleteAll(): Promise<any> {
        const query = `DELETE FROM ${ DriverInfo.TABLENAME };`;
        return this.sqlProvider.query(query, []);
    }

    public get(id: string, hydrate: boolean = false): Promise<DriverInfo> {
        if (isNullOrEmpty(id)) {
            return Promise.resolve(null);
        }
        const query = `SELECT * FROM ${ DriverInfo.TABLENAME } WHERE id = ?;`;
        return this.sqlProvider.query(query, [id])
            .then(data => {
                if (data.rows.length <= 0) {
                    return null;
                }
                return this.rowToModel(data.rows[0]);
            })
            .catch(reason => {
                this.logSqlError(reason);
                return null;
            });
    }

    public getTableName(): string {
        return DriverInfo.TABLENAME;
    }

    protected rowToModel(row: any): DriverInfo {
        let driverInfo = new DriverInfo();
        driverInfo.id = row.id;
        driverInfo.birthDate = row.birthDate;
        driverInfo.driverLicenseNumber = row.driverLicenseNumber;
        driverInfo.driverLicenseIssuingDate = row.driverLicenseIssuingDate;
        driverInfo.driverLicenseIssuingPlace = row.driverLicenseIssuingPlace;
        return driverInfo;
    }

    public save(driverInfo: DriverInfo): Promise<DriverInfo> {
        const query = `INSERT OR REPLACE INTO ${ DriverInfo.TABLENAME }
            (id, birthDate, driverLicenseNumber, driverLicenseIssuingDate, driverLicenseIssuingPlace)
            VALUES (?, ?, ?, ?, ?);`;
        const values = [
            driverInfo.id,
            driverInfo.birthDate,
            driverInfo.driverLicenseNumber,
            driverInfo.driverLicenseIssuingDate,
            driverInfo.driverLicenseIssuingPlace,
        ];
        return this.sqlProvider.query(query, values)
            .then(response => {
                return driverInfo;
            })
            .catch(reason => {
                this.logSqlError(reason);
                return null;
            });
    }
}
